"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _axios = _interopRequireDefault(require("axios"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
} // TODO: Replace /toggles.aspx with API endpoint when available


var TOGGLES_URL = "/toggles.aspx"; // Promise-based class to fetch toggles

var ToggleService =
/*#__PURE__*/
function () {
  function ToggleService() {
    _classCallCheck(this, ToggleService);

    this._toggles = null;
  } // TODO: When updating to use API, this method should instead
  // be used to setup an internal config object for axios
  // containing the access_token required by our APIs


  _createClass(ToggleService, [{
    key: "init",
    value: function init() {
      var _this = this; // Fetch all toggles and store internally


      return new Promise(function (resolve, reject) {
        _axios.default.get(TOGGLES_URL).then(function (res) {
          _this._toggles = res.data; // Freeze toggles object to prevent manual toggle changes

          Object.freeze(_this._toggles);
          resolve();
        }).catch(function (err) {
          reject(err);
        });
      });
    } // TODO: Update method to fetch toggles from API endpoint and store internally

  }, {
    key: "getToggles",
    value: function getToggles() {
      var _this2 = this;

      return new Promise(function (resolve, reject) {
        // Fetch toggles if not already present
        if (!_this2._toggles) {
          _this2.init().then(function () {
            resolve(_this2._toggles);
          }).catch(function (err) {
            reject(err);
          });
        } else {
          resolve(_this2._toggles);
        }
      });
    } // TODO: Update method to fetch a single toggle value from API endpoint
    // and store the value internally

  }, {
    key: "getToggle",
    value: function getToggle(ticket) {
      var _this3 = this;

      return new Promise(function (resolve, reject) {
        // Fetch toggles if not already present
        if (!_this3._toggles) {
          _this3.init().then(function () {
            resolve(_this3._toggles[ticket]);
          }).catch(function (err) {
            reject(err);
          });
        } else {
          resolve(_this3._toggles[ticket]);
        }
      });
    }
  }]);

  return ToggleService;
}();

var _default = ToggleService; // Example Usages:
// var toggleService = new ToggleService();
// var toggle = await toggleService.getToggle("SP_36626")
// var allToggles = await toggleService.getToggles();
// toggleService.getToggle("SP_36626").then(toggle => { toggle ? doStuff() : doStuff_sp36626() });
// toggleService.getToggles().then(allToggles => dispatch({type: "TOGGLES", allToggles}));

exports.default = _default;